define('EndlessShelfProducts.Facets.ItemCell.View', [
    'Facets.ItemCell.View',
    'underscore'
], function EndlessShelfProductsFacetsItemCellView(
    FacetsItemCellView,
    _
) {
    'use strict';

    _.extend(FacetsItemCellView.prototype, {
        getContext: _.wrap(FacetsItemCellView.prototype.getContext, function getContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            originalContext.endlessProduct = this.model.get('custitem_endless_shelf_message');
            return originalContext;
        })
    });
});
